import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorhandelerService implements ErrorHandler {
  constructor() {

  }
  handleError(error: unknown): void {
    // You can inject services if needed (like logging, notifications)
    console.log('Global Error', error);
    //Swal.fire('Error', 'Something went wrong', 'error');

    if (error instanceof HttpErrorResponse) {
      // Handle HTTP errors
      console.error('HTTP Error Status:', error.status);
    } else if (error instanceof Error) {
      // Handle client-side errors
      console.error('Client Error Message:', error.message);
    } else {
      // Unknown error
      console.error('Unknown error occurred');
    }
  }
}
